interface BooleanToggleProps {
  value: boolean
  onChange: (value: boolean) => void
  trueLabel?: string
  falseLabel?: string
  disabled?: boolean
  hasError?: boolean
}

/**
 * ON/OFF segmented toggle control.
 * Used for boolean equipment status fields.
 */
export function BooleanToggle({
  value,
  onChange,
  trueLabel = "ON",
  falseLabel = "OFF",
  disabled = false,
  hasError = false,
}: BooleanToggleProps) {
  return (
    <div
      className={`inline-flex rounded-lg border overflow-hidden ${
        hasError ? "border-red-300" : "border-slate-200/50"
      } ${disabled ? "opacity-50" : ""}`}
    >
      <button
        type="button"
        onClick={() => !disabled && onChange(true)}
        disabled={disabled}
        className={`px-4 py-2 text-sm font-medium transition-colors ${
          value
            ? "bg-emerald-500 text-white"
            : "bg-white text-gray-700 hover:bg-slate-50"
        } ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
      >
        {trueLabel}
      </button>
      <button
        type="button"
        onClick={() => !disabled && onChange(false)}
        disabled={disabled}
        className={`px-4 py-2 text-sm font-medium transition-colors border-l ${
          hasError ? "border-red-300" : "border-slate-200/50"
        } ${
          !value
            ? "bg-slate-500 text-white"
            : "bg-white text-gray-700 hover:bg-slate-50"
        } ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
      >
        {falseLabel}
      </button>
    </div>
  )
}
